import { render, staticRenderFns } from "./VTh.vue?vue&type=template&id=23b0d466&"
import script from "./VTh.vue?vue&type=script&lang=ts&"
export * from "./VTh.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports